import React, { useEffect } from 'react';
import { Route, Switch, Redirect } from "react-router-dom";
import useGlobalModel from "./model/globalModel";
import { Login } from "./views/login/Login";
import Index from "./layout";
import { useDictModel } from "./views/base/dict/dictModel";
import { setToken } from './utils/constants';
import TokenLogin from './views/login/TokenLogin'
import { urlParse } from "@/utils/utils";


function App() {
    const { user: { token }, requestCacheAll } = useGlobalModel(({ user }) => [user]);
    const { loadData: dictLoadData } = useDictModel(() => []);


    useEffect(() => {
        if (token) {
            dictLoadData();     //初始字典缓存
            requestCacheAll();
            // console.log(window.screen)
        }
    }, [token])

    function loginCheck() {
        // const url = 'https://localhost:3000?token=90d587565ba24df99d4f804fb931d2c8'
        const url = window.location.href
        let urlObj = urlParse(url);

        if (urlObj.token) {
            setToken(urlObj.token)
            return <TokenLogin token={urlObj.token} />
        }
        return <Login />
    }

    return (
        <Switch>
            <Route path="/login" component={() => loginCheck()} />
            <Route path="/" render={
                () => token ? <Index /> : <Redirect to="/login" />}
            />
        </Switch>
    );
}

export default App;
